<template lang="">
          <v-card>
              <v-toolbar>
                <v-spacer></v-spacer>

              <v-col cols="3" class="mt-5">
                   <v-select
                   prepend-icon="mdi-map-marker"
                    :items="sucursal"
                    label="Filtro por localidad"
                    v-model="filtro_localidad"
                  ></v-select>
                </v-col>

                <v-col cols="3" class="mt-5">
                   <v-select
                   prepend-icon="mdi-home-modern"
                    :items="empresas"
                    label="Filtro por Empresa"
                    v-model="filtro_empresa"
                  ></v-select>
                </v-col>

                <v-col cols="3" class="mt-5">
                  <v-text-field
                  prepend-icon="mdi-calendar-today"
                    :label="filtro_inicio?`fecha desde: ${filtro_inicio}` :`Fecha desde: (por defecto: ${dia})`"
                    type="date"
                    v-model="filtro_inicio"
                ></v-text-field>
                </v-col>

                <v-col cols="3" class="mt-5">
                  <v-text-field
                  prepend-icon="mdi-calendar-multiple"
                    :label="filtro_fecha? `fecha hasta: ${filtro_fecha}` :`Fecha hasta: (por defecto: ${dia})`"
                    type="date"
                    v-model="filtro_fecha"
                    
                ></v-text-field>
                </v-col>
                 
                
                

              
                

              </v-toolbar>
            </v-card>
</template>
<script>

import moment from 'moment';

export default {
    
    mounted() {
        this.añadirFecha()
    },

    data(){
        return {

            filtro_empresa:'',
            filtro_localidad:'',
            filtro_inicio: '',
            filtro_fecha: '',


            dia:moment(new Date()).format("YYYY-MM-DD"),
        }
    },

    computed: {
        
        empresas(){
            return this.$store.getters.obtenerEmpresas;
        },
        sucursal(){
            return this.$store.getters.obtenerSucursales;
        },

    },

    watch: {
        
        filtro_localidad(item){
          this.$store.dispatch('filtertable', {type:'Fecha',  item:{inicio:this.filtro_fecha?this.filtro_fecha:moment(new Date()).format("YYYY-MM-DD"), final:this.filtro_inicio?this.filtro_inicio:moment(new Date()).format("YYYY-MM-DD"),empresa:this.filtro_empresa?this.filtro_empresa:'all',localidad:this.filtro_localidad?this.filtro_localidad:'all'} });
        },

        filtro_empresa(item){
           this.$store.dispatch('filtertable', {type:'Fecha',  item:{inicio:this.filtro_fecha?this.filtro_fecha:moment(new Date()).format("YYYY-MM-DD"), final:this.filtro_inicio?this.filtro_inicio:moment(new Date()).format("YYYY-MM-DD"),empresa:this.filtro_empresa?this.filtro_empresa:'all',localidad:this.filtro_localidad?this.filtro_localidad:'all'} });
         },

         filtro_fecha(item){
           this.$store.dispatch('filtertable', {type:'Fecha',  item:{inicio:this.filtro_fecha?this.filtro_fecha:moment(new Date()).format("YYYY-MM-DD"), final:this.filtro_inicio?this.filtro_inicio:moment(new Date()).format("YYYY-MM-DD"),empresa:this.filtro_empresa?this.filtro_empresa:'all',localidad:this.filtro_localidad?this.filtro_localidad:'all'} });
         },

         filtro_inicio(item){
           this.$store.dispatch('filtertable', {type:'Fecha',  item:{inicio:this.filtro_fecha?this.filtro_fecha:moment(new Date()).format("YYYY-MM-DD"), final:this.filtro_inicio?this.filtro_inicio:moment(new Date()).format("YYYY-MM-DD"),empresa:this.filtro_empresa?this.filtro_empresa:'all',localidad:this.filtro_localidad?this.filtro_localidad:'all'} });
         },
        
    },

    methods: {
        añadirFecha:function(){
            this.$store.dispatch('filtertable', {type:'Fecha',  item:{inicio:this.filtro_fecha?this.filtro_fecha:moment(new Date()).format("YYYY-MM-DD"), final:this.filtro_inicio?this.filtro_inicio:moment(new Date()).format("YYYY-MM-DD"),empresa:this.filtro_empresa?this.filtro_empresa:'all',localidad:this.filtro_localidad?this.filtro_localidad:'all'} });
        }
    },


}
</script>